import * as userStore from './user';

export const commonStore = {
    [userStore.name]: userStore,
} as const;

export type CommonStore = typeof commonStore;
